<template lang="pug">
  .ui-navbar-tabs
    template(v-if="isRouterMode")
      b-navbar-item.navbar-tab(v-for="tab,i in items" :key="i" tag="router-link" :to="tab.route")
        b-icon.mr-5(v-if="tab.icon" :icon="tab.icon")
        span {{tab.label}}
    template(v-else)
      b-navbar-item.navbar-tab(v-for="tab,i in items" :key="i" @click="selectTab(i)" :class="{'is-active': i === innerValue}")
        b-icon.mr-5(v-if="tab.icon" :icon="tab.icon")
        span {{tab.label}}
</template>

<script>
export default {
  name: 'ui-navbar-tabs',

  props: {
    items: Array,
    actions: Array,
    value: Number,
  },

  data: () => ({
    innerValue: 0,
  }),

  methods: {
    selectTab(index) {
      this.innerValue = index;
      this.$emit('input', index);
    },
  },

  watch: {
    value(value) {
      this.innerValue = value;
    },
  },
  computed: {
    firstItem() {
      return this.items && this.items.length > 0 ? this.items[0] : null;
    },

    isRouterMode() {
      return this.firstItem && this.firstItem.route;
    },
  },
};
</script>

<style lang="scss">
.ui-navbar-tabs {
  display: flex;
}
</style>
